import { Component, OnInit, Input, OnChanges } from '@angular/core';

import { environment } from '../../../environments/environment';

import { HttpErrorHandler } from '../../shared/http-error-handler';
import { NotificationsService } from '../../_services/notifications.service';

import { ExportDataService } from '../../_services/export-data.service';

@Component({
  selector: 'app-export-view',
  templateUrl: './export-view.component.html',
  styleUrls: ['./export-view.component.css'],
})
export class ExportViewComponent implements OnChanges {
  @Input() filterParams: string;
  protected maxRecordsAllowed = environment.maxExportRecords;
  protected recordsCount: number;
  protected error: boolean;

  constructor(
    private exportDataService: ExportDataService,
    private httpErrorHandler: HttpErrorHandler,
    private notificationsService: NotificationsService
  ) {}

  ngOnChanges(changes: any) {
    if (changes.filterParams) {
      if (changes.filterParams.currentValue !== undefined) {
        this.getExportData(changes.filterParams.currentValue);
      }
    }
  }

  getExportData(params) {
    this.error = false;
    this.exportDataService.list(1, 10, params, '').subscribe(
      (response) => {
        this.recordsCount = response.count;
        if (this.recordsCount > this.maxRecordsAllowed) {
          this.error = true;
        } else {
          this.exportToExcel();
        }
      },
      (error) => {
        const msg = this.httpErrorHandler.handleHttpError(error)[0];
        this.notificationsService.notify('error', 'Error', msg);
      }
    );
  }

  exportToExcel() {
    event.preventDefault();
    this.exportDataService.exportToExcel().subscribe(
      (response) => {
        this.exportDataService.downloadExcel(response.token, this.filterParams, []);
      },
      (error) => {
        const msg = this.httpErrorHandler.handleHttpError(error)[0];
        this.notificationsService.notify('error', 'Error', msg);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/export/export-view/export-view.component.ts